var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcludeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 0.000519748H0.000275608V131.001C0.269135 58.7716 58.7714 0.26938 131 0.000519748Z",
    fill: "#E5F4EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludeIcon);
export default __webpack_public_path__ + "static/media/Exclude-icon.da73ed993911947df59c57fbb51872db.svg";
export { ForwardRef as ReactComponent };